import axios from 'axios';
import {backendHost} from '../../config';

export const postPromoFixed = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/promo/fixed`, params);
};